import { render, staticRenderFns } from "./SupplierRfqDetailMaintain.vue?vue&type=template&id=caba6d20&scoped=true"
import script from "./SupplierRfqDetailMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierRfqDetailMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caba6d20",
  null
  
)

export default component.exports